import { Button, CircularProgress } from '@mui/material';
import classNames from 'classnames';
import { memo } from 'react';

import { ICTAButtonProps } from './CTAButton.types';
import styles from './styles.module.scss';

// TODO: Add colorMode to handle color internally
const CTAButton = memo<ICTAButtonProps>(({ children, linkStyle, isLoading, ...props }) => (
  <Button
    {...props}
    className={classNames(styles.button, props.className, {
      [styles.disabled]: props.disabled,
      [styles.link]: linkStyle,
    })}
    variant={linkStyle ? 'text' : props.variant ?? 'contained'}
    disabled={props.disabled || isLoading}
  >
    {isLoading ? <CircularProgress className={styles.circularProgress} /> : children}
  </Button>
));

CTAButton.displayName = 'CTAButton';

export default CTAButton;
